export type Environment = 'local' | 'develop' | 'staging' | 'production'

/**
 *  Get the current environment the app is running in
 * @returns {string} the environment name
 */
export const buildEnv: Environment = import.meta.env.VITE_ENVIRONMENT

/**
 *  Determine if the api is running in a locally
 * @returns {string} the environment name
 */
export const isApiLocal = import.meta.env.VITE_DMW_BASE_URL.includes('localhost')

/**
 *  Determine if the current environment is staging
 * @returns {boolean} True when the environment is production
 */
export const isStaging = buildEnv === 'staging'

/**
 *  Determine if the current environment is production
 * @returns {boolean} True when the environment is production
 */
export const isProduction = buildEnv === 'production'

/**
 *  Determine if the current environment is local
 * @returns {boolean} True when the environment is production
 */
export const isLocal = buildEnv === 'local'

/**
 *  Determine if the current environment is develop
 * @returns {boolean} True when the environment is production
 */
export const isDev = buildEnv === 'develop'

/**
 *  Determine if the current environment is lower than production
 * @returns {boolean} True when the environment is NOT production
 */
export const isLowerEnvironment = buildEnv !== 'production'

/**
 *  Determine if the current environment is the local
 * @returns {boolean} True when the environment is NOT production
 */
export const isLocalEnvironment = buildEnv === 'local'
